import cn from 'classnames';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { routerPath } from 'src/app/router/ui/AppRouter';
import { SingleInfo } from 'src/entities/SingleInfo';
import { UpdateCompanyData } from 'src/features/UpdateCompanyData/UpdateCompanyData';
import CompanySvg from 'src/shared/assets/svg/illustrations/undraw_survey_05s5.svg';
import { DivProps } from 'src/shared/types/props';
import { ButtonPrimary } from 'src/shared/ui/_buttons/ButtonPrimary';
import { ButtonsWrapper } from 'src/shared/ui/_layout/ButtonsWrapper';
import s from './CompanyCard.module.scss';

interface Props extends DivProps {
	companyId: number;
	companyName: string;
}

export const CompanyCard: React.FC<Props> = (props) => {
	const {
		companyId, //
		companyName,
		className,
		...divProps
	} = props;

	// * Router
	const navigate = useNavigate();

	const openEditCompany = () => navigate(routerPath.companyPage + `/${companyId}`);

	// * Render
	return (
		<div
			{...divProps}
			className={cn(s.container, className)}
		>
			<div>
				<div className={s.info}>
					<SingleInfo
						data-test={'company_card_dei_id'}
						caption="D ID"
						info={companyId}
					/>

					<SingleInfo
						data-test={'company_card_company_name'}
						caption="Name"
						info={companyName}
					/>
				</div>

				<ButtonsWrapper>
					<ButtonPrimary
						data-test={'company_card_edit_button'}
						style={{ height: '3.5rem' }}
						onClick={openEditCompany}
					>
						Update data
					</ButtonPrimary>

					<UpdateCompanyData companyId={companyId} />
				</ButtonsWrapper>
			</div>

			<CompanySvg className={s.img} />
		</div>
	);
};
